/**
 * Modal component
 * 
 * @param {NodeElement} el main modal element
 * @param {Object} config configuration options.
 * @param {string} [config.dataset="data-modal"] - dataset attribute where the open value will be applied.
 * @param {string} [config.dataset_describedby="data-modaldescribedby"] - dataset attribute that will be used by aria-describedby.
 * @param {string} [config.open_again_to_close=true] - call open on an opened modal closes the modal
 * @param {NodeElement[]} [config.closebuttons=[]] - elements that will be used as close buttons.
 * @param {MpVideo[]} [config.videos=[]] - video list (if any). It's important to be able to activate them on open and put them to sleep on modal close.
 */
function MpModal(el, config) {
	this.el				= el;
	this.config			= {};
	var defaultConfig 	= {
		dataset: "data-modal",
		dataset_describedby: "data-modaldescribedby",
		open_again_to_close: true,
		closebuttons:[],
		videos:[]
	};

	Object.assign(this.config, defaultConfig, config);
}
MpModal.prototype.init = function (){
	//Accesibility
	this.el.setAttribute('role', 'dialog');
	this.el.setAttribute('aria-modal', 'true');

	//Try to find a heading to associate the aria-labelledby
	var hNodes = this.el.querySelectorAll('h1, h2, h3, h4, h5, h6');

	if(hNodes.length > 0){
		var hInfo = {level: 6, node: null};
		Array.prototype.forEach.call(hNodes, function(hNode){
			var hLevel = hNode.tagName.substring(1);

			if(hLevel < hInfo.level){
				hInfo.level = hLevel;
				hInfo.node	= hNode;
			}
		});

		//Si no tiene un id se lo asignamos
		if(!hInfo.node.id){
			hInfo.node.setAttribute('id', 'mh-' + Math.floor(Math.random() * 10000)); 
		}
		this.el.setAttribute('aria-labelledby', hInfo.node.id);
	}

	//Try to find body to associate the aria-describedby
	var describedbyNodes = this.el.querySelectorAll('[' + this.config.dataset_describedby + ']');

	if(describedbyNodes.length > 0){
		//Si no tiene un id se lo asignamos
		if(!describedbyNodes[0].id){
			describedbyNodes[0].setAttribute('id', 'md-' + Math.floor(Math.random() * 10000)); 
		}
		this.el.setAttribute('aria-describedby', describedbyNodes[0].id);
	}

	//Listeners
	this.el.addEventListener('keydown', (e) =>{
		//Close on Escape
		if(e.key === "Escape") {
			this.close();
			e.preventDefault();
		}
		//Tab & Shift+Tab cycles focus inside modal elements only
		else if(e.key === "Tab") {
			if(document.activeElement){
				var focusableElements = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

				if(e.shiftKey && (focusableElements[0] === document.activeElement || this.el === document.activeElement)){
					focusableElements[focusableElements.length - 1].focus();
					e.preventDefault();
				}
				else if(!e.shiftKey && focusableElements[focusableElements.length - 1] === document.activeElement){
					focusableElements[0].focus();
					e.preventDefault();
				}
			}
		}
	});
	var self = this;
	this.config.closebuttons.forEach(function(item){
		item.addEventListener('click', function(event){
			self.close();
		});
		item.addEventListener('keypress', function(e){
			if(e.key === "Enter") {
				self.close();
				e.preventDefault();
			}
		});
	});
};
/**
 * Open modal. Initializes otVideo list.
 */
MpModal.prototype.open = function (){
	if(this.config.open && this.config.open_again_to_close){
		this.close();
	}
	else{
		this.activeElementBeforeOpen = document.activeElement;

		Array.prototype.forEach.call(this.config.videos, function(video){
			video.init();
		});
	
		this.el.setAttribute(this.config.dataset, 'open');
		this.el.setAttribute('tabindex', 0);
		this.el.focus();
	
		this.config.open = true;
	}
};
/**
 * Close modal and destroy otVideo list. Also return the focus to the opener node if it has been provided
 */
MpModal.prototype.close = function(){
	//Destruimos los videos al cerrar para evitar que se reproduzcan (Vimeo da problemas si simplemente le cambiamos el src al iframe)
	Array.prototype.forEach.call(this.config.videos, function(video){
		video.sleep();
	});

	this.el.setAttribute(this.config.dataset, '');

	//Return focus to the element that had it before open
	this.activeElementBeforeOpen.focus();

	this.config.open = false;
};
MpModal.prototype.setOpener = function(el){
	this.config.opener = el;
};
/**
 * Helper for initializing {MpModal}
 * 
 * @param {json} config 
 */
function MpModalHelper(config) {
	this.config			= {};
	const defaultConfig = {
		attach_to:			document.body,
		dataset_close: 		"data-modalclose", 	//data attribute inside modal that set elements that will close the modal after click / Enter
		dataset_open: 		"data-modalopen", 	//data attribute with the modal id that will be open after click / Enter
		dataset_modalid: 	"data-modalid", 	//data attribute with the modal id
		video:{
			"facebook_page": "",
			"dataset": 		 "data-video-modal"
		}
	};

	Object.assign(this.config, defaultConfig, config);
}
/**
 * Returns the modal object with its inner videos, close buttons and opener associated buttons
 * 
 * @param {NodeElement} el 
 * @returns {MpModal} modal object
 */
MpModalHelper.prototype.getModal = function (el){
	//Let's reattach modal to some element (normally body to avoid z-index problems)
	if(this.config.attach_to && this.config.attach_to !== null){
		this.config.attach_to.appendChild(el);
	}

	/** 
	 * We are not using this at the moment 
	 */
	// //Find videos inside modal element
	// const vh 		= new MpVideoHelper(this.config.video);
	const videos 	= [];
	
	// Array.prototype.forEach.call(el.querySelectorAll('[' + vh.config.dataset + ']'), function(el) {
	// 	videos.push(vh.getVideo(el));
	// });

	const modal = new MpModal(el, {videos: videos, closebuttons: el.querySelectorAll('[' + this.config.dataset_close + ']')});
	
	//Buscamos si hay algún botón que abra este modal
	const modalId = el.getAttribute(this.config.dataset_modalid);

	Array.prototype.forEach.call(document.querySelectorAll('[' + this.config.dataset_open + '="' + modalId + '"]'), function(btn) {
		const opener = new MpModalOpener(btn, {"modal": modal});
		opener.init();
	});

	return modal;
};
/**
 * Modal opener element
 * 
 * @param {NodeElement} el 
 * @param {json} config configuration options
 */
function MpModalOpener(el, config) {
	this.el				= el;
	this.config			= {};
	const defaultConfig = {
		modal: null
	};

	Object.assign(this.config, defaultConfig, config);
}
MpModalOpener.prototype.init = function (){
	this.el.addEventListener('click', (event) => {
		this.open();
	});
	this.el.addEventListener('keypress', (e) => {
		if(e.key === "Enter") {
			this.open();
		}
		e.preventDefault();
	});
};
/**
 * Abre el modal
 */
MpModalOpener.prototype.open = function(){
	this.config.modal.open();
};



document.addEventListener("DOMContentLoaded", function () {
	const mh = new MpModalHelper();
	Array.prototype.forEach.call(
		document.querySelectorAll("[data-modal]"),
		function (el) {
			mh.getModal(el).init();
		}
	);
});